/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.label.optional\":[\"Valgfri\"],\"checkbox-group.validation.required\":[\"Minst ett valg er påkrevd.\"]}");
//# sourceMappingURL=messages.mjs.map